import { render, staticRenderFns } from "./HomeCase.vue?vue&type=template&id=56c4ac00&scoped=true"
import script from "./HomeCase.vue?vue&type=script&lang=js"
export * from "./HomeCase.vue?vue&type=script&lang=js"
import style0 from "./HomeCase.vue?vue&type=style&index=0&id=56c4ac00&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "56c4ac00",
  null
  
)

export default component.exports